<template lang="pug">
div
  div.form-check.mb-3
    input#specific_week_date.form-check-input(type='checkbox', name='specific_week_date', @click='setSpecificWeekDate', :checked="scope.specific_week_date", value=1)
    div.d-flex.align-items-center.mb-3
      label.form-check-label(for='specific_week_date') 表示曜日・時間を指定する
      span.upper-master-label.ml-2 Master以上
      UpgradeUpperMaster(v-if="is_upgrade_upper_master_modal", @close-modal="is_upgrade_upper_master_modal = false")
  div.form-group(v-if="scope.specific_week_date")
    .row.pl-4
      .col-12
        div.form-group(v-for="(weekday, index) in weekdays" :key="index")
          input.form-check-input(type='checkbox', :id="'week_date_' + (index+1)", :name="'week_date_' + (index+1)", :checked="isSelectedWeekday(index+1)", @change="setCreativeDisplayWeekDate(index+1)")
          div.d-flex.align-items-center.mb-3
            label.form-check-label(:for="'week_date_' + (index+1)") {{ weekday }}
          div.ml-3(v-if="isSelectedWeekday(index+1)")
            div(v-for="(time, timeIndex) in getSelectedWeekdayTimes(index+1)" :key="timeIndex")
              .row.mt-2
                .col-5
                  input.form-control(type="time" v-model="time.time_from")
                .col-1.text-center.pt-2 〜
                .col-5
                  input.form-control(type="time" v-model="time.time_to")
                .col-1.text-center.pt-2
                  i.fa.fa-times.text-danger(@click="removeSelectedTime(index+1, timeIndex)")
            .row.mt-2
              .col-12.text-center
                button.btn.btn-sm.btn-outline-secondary.mr-4(@click="addSelectedTime(index+1)") + 追加
        input#hide_holiday.form-check-input(type='checkbox', name='hide_holiday', @click='setHideHoliday', :checked="scope.hide_holiday", value=1)
        div.d-flex.align-items-center.mb-3
          label.form-check-label(for='hide_holiday') 祝日にポップアップを表示しない

</template>

<script>
//libs
import UpgradeUpperMaster from "../modals/upgrade_upper_master.vue";

export default {
  props: {
    show_with_parameters: { type: Boolean, default: false },
  },
  data(){
    return {
      is_upgrade_upper_master_modal: false,
      weekdays: ['月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日', '日曜日'],
    }
  },
  methods: {
    isDisplayModal(e) {
      this.is_upgrade_upper_master_modal = true;
      e.preventDefault();
    },
    setSpecificWeekDate(e) {
      this.$store.commit("creative/setSpecificWeekDate", e.target.checked);
    },
    setHideHoliday(e) {
      this.$store.commit("creative/setHideHoliday", e.target.checked);
    },
    setCreativeDisplayWeekDate(weekNumber) {
      if (this.isSelectedWeekday(weekNumber)) {
        this.$store.commit("creative/emptyCreativeDisplayWeekDateTime", { week_number: weekNumber });
      } else {
        this.$store.commit("creative/addCreativeDisplayWeekDateTime", { week_number: weekNumber, time: { time_from: null, time_to: null } });
      }
    },
    isSelectedWeekday(weekNumber) {
      const weekDate = this.scope.creative_display_week_dates.find(date => date.week_number === weekNumber);
      return weekDate && weekDate.times.length > 0;
    },
    getSelectedWeekdayTimes(weekNumber) {
      const weekDate = this.scope.creative_display_week_dates.find(date => date.week_number === weekNumber);
      return weekDate ? weekDate.times : [];
    },
    addSelectedTime(weekNumber) {
      const weekDate = this.scope.creative_display_week_dates.find(date => date.week_number === weekNumber);
        if (weekDate && weekDate.times.length >= 2) {
          alert("1つの曜日に設定できる時間は2件までです。");
          return;
        }
      this.$store.commit("creative/addCreativeDisplayWeekDateTime", { week_number: weekNumber, time: { time_from: null, time_to: null } });
    },
    removeSelectedTime(weekNumber, timeIndex) {
      this.$store.commit("creative/removeCreativeDisplayWeekDateTime", { week_number: weekNumber, time_index: timeIndex });
    },
    validateSelectedTime(time) {
      if (time.time_from && time.time_to && time.time_to <= time.time_from) {
        alert("終了時刻は開始時刻より後の時間を指定してください。");
        return false;
      }
    },
  },
  components: {
    UpgradeUpperMaster,
  },
  computed: {
    scope() {
      return {
        specific_week_date: this.$store.state.creative.preview_list.specific_week_date,
        creative_display_week_dates: this.$store.state.creative.preview_list.creative_display_week_dates,
        hide_holiday: this.$store.state.creative.preview_list.hide_holiday,
      }
    },
  },
  watch: {
    'scope.creative_display_week_dates': {
      handler(newValue) {
        newValue.forEach(weekDate => {
          weekDate.times.forEach(time => {
            this.validateSelectedTime(time);
          });
        });
      },
      deep: true,
    },
  },
}
</script>
<style lang="scss" scoped>

</style>
